<div class="flex h-screen overflow-hidden">
  @if (!auth.isSystemAdmin() || auth.isImpersonating()) {
  <app-sidebar [mobileOpen]="sidebarToggle()" (mobileClose)="closeSidebar()"></app-sidebar>
  }
  <div class="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden"
    [class.ml-0]="auth.isSystemAdmin() && !auth.isImpersonating()">
    <!-- Mobile overlay backdrop - closes sidebar when clicked -->
    <div (click)="closeSidebar()" [ngClass]="sidebarToggle() ? 'block lg:hidden' : 'hidden'"
      class="fixed inset-0 z-[9998] bg-gray-900/50 transition-opacity duration-300"></div>
    <app-grace-period-banner></app-grace-period-banner>
    <app-header [mobileSidebarOpen]="sidebarToggle()" (sidebarToggle)="toggleSidebar()"></app-header>
    <main>
      @if (auth.isSystemAdmin() && !auth.isImpersonating()) {
      <router-outlet></router-outlet>
      } @else {
      <div class="mx-auto max-w-(--breakpoint-2xl) p-3 md:p-4">
        <app-page-header
          [title]="title()"
          [subtitle]="subtitle()"
          [breadcrumbs]="breadcrumbs()">
        </app-page-header>
        <router-outlet></router-outlet>
      </div>
      }
    </main>
  </div>
</div>
<!-- Modal desactivado temporalmente -->
<!-- @if(businessService.needsBusinessInfo() && !auth.isSystemAdmin()) {
<app-modal-register-business></app-modal-register-business>
} -->
<app-welcome-modal></app-welcome-modal>
